import React from 'react'
import { FieldRenderProps } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { Error } from '@progress/kendo-react-labels';

interface ITextInputProps extends FieldRenderProps{
    icon:string;
    placeholder:string;
}

const TextInput = function (fieldRenderProps: ITextInputProps) {
    const { validationMessage, touched, icon, placeholder, ...others } = fieldRenderProps;

    return (
        <div className="text-input-container">
            <span className="k-textbox k-space-left">
                <i className={'k-p-3 k-icon-input k-icon ' + icon}/>
                <Input {...others} placeholder={placeholder} />
            </span>
            {validationMessage !== "" && touched && (
                <Error>{validationMessage}</Error>
            )}
        </div>
    )
}

export default TextInput;
